export const searchJobsRoutePathByLocale = {
  en: '/en/jobs',
  es: '/es/empleos',
  pt: '/pt/empregos',
} as const;

export const searchJobsRoutePaths = Object.values(searchJobsRoutePathByLocale);

export const searchJobsRoutePathsWithoutLang = Array.from(
  new Set(searchJobsRoutePaths.map((path) => path.substring(3))),
);
